function parseUpsellItems(filteredCategoryMenuItems, upsellOrderItems) {
  const filteredUpsellItems = filterUpsellMenuItems(filteredCategoryMenuItems, upsellOrderItems);

  const modalUpsellItems = [];

  filteredUpsellItems.forEach((upsellItem) => {
    const upsellCategoryIdxMatch = modalUpsellItems.findIndex(item => item.menuCategoryId === upsellItem.menuCategoryId);

    if (upsellCategoryIdxMatch !== -1) {
      modalUpsellItems[upsellCategoryIdxMatch].items.push(upsellItem);

      if (upsellItem.sortOrder) {
        modalUpsellItems[upsellCategoryIdxMatch].items.sort((a, b) => a.sortOrder - b.sortOrder);
      }
    }
    else {
      const requiresSorting = upsellItem.menuCategorySortOrder;

      const item = { menuCategoryId: upsellItem.menuCategoryId, menuCategoryDisplayName: upsellItem.upsellCategoryName, items: [upsellItem] };

      if (requiresSorting) {
        Object.assign(item, { menuCategorySortOrder: upsellItem.menuCategorySortOrder });
      }

      modalUpsellItems.push(item);

      if (requiresSorting) {
        modalUpsellItems.sort((a, b) => a.menuCategorySortOrder - b.menuCategorySortOrder);
      }
    }
  });

  return {
    checkoutUpsellItems: filteredUpsellItems.map(sanitizeUpsellItems),
    modalUpsellItems: sanitizeModalUpsellItems(modalUpsellItems)
  };
}

function sanitizeUpsellItems({ sortOrder, menuCategorySortOrder, ...rest }) {
  const sanitzedItem = { ...rest };

  return sanitzedItem;
}

function sanitizeModalUpsellItems(modalUpsellItems) {
  const categories = [];

  modalUpsellItems.forEach(({ menuCategorySortOrder, items, ...rest }) => {
    const sanitizedUpsellItems = items.map(sanitizeUpsellItems);

    categories.push({ ...rest, items: sanitizedUpsellItems });
  });

  return categories;
}

function filterUpsellMenuItems(menuCategories, upsellOrderItems) {
  const filteredResult = [];

  menuCategories.forEach((menuCategory) => {
    const isFavoriteCategory = menuCategory.categoryTemplate === 'FavoritesCategoryTemplate';

    if (!isFavoriteCategory) {
      upsellOrderItems.forEach((upsellItem) => {
        const categoryUpsellItemMatch = menuCategory.menuItems.find(menuCategoryItem => menuCategoryItem.menuItemId === upsellItem.menuItemId);

        if (categoryUpsellItemMatch) {
          const menuItem = { ...upsellItem, ...categoryUpsellItemMatch, isUpsell: true, upsellCategoryName: menuCategory.displayName };

          const isClonedItem = filteredResult.find(result => result.menuItemId === menuItem.menuItemId);

          if (!isClonedItem) {
            filteredResult.push(menuItem);
          }
        }
      });
    }
  });

  return filteredResult;
}

export default parseUpsellItems;
